// Definition of the configurations for the motion Viewport Observer
const headingViewportConfig = { once: true, amount: "all" };
const cardViewportConfig = { once: true, amount: 0.25 };

export { headingViewportConfig, cardViewportConfig };
